export function formatNumber(val: number, roundDecimals?: number) {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: roundDecimals,
    maximumFractionDigits: roundDecimals,
  });

  return formatter.format(val);
}
